export enum LinkedInStatus {
  OptOut = 'OptOut',
  // Data sharing is enabled from both Microsoft and LinkedIn
  Bound = 'Bound',
  // Data sharing is disabled from both Microsoft and LinkedIn
  Unbound = 'Unbound',
  // Data sharing is enabled only from LinkedIn to Microsoft
  LinkedInBound = 'LinkedInBound',
  // Data sharing is enabled only from Microsoft to LinkedIn
  MicrosoftBound = 'MicrosoftBound',
  DisabledBound = 'DisabledBound',
}
